import { FormElementAttributes } from "@types";
import { useFormikContext } from "formik";
import { ReactElement } from "react";
import CheckboxInput from "./checkbox-input";
import DateInput from "./date-input";
import EmailInput from "./email-input";
import FileInput from "./file-input";
import HiddenInput from "./hidden-input";
import NumberInput from "./number-input";
import RadioInput from "./radio-input";
import SelectInput from "./select-input";
import SubmitInput from "./submit-input";
import TelInput from "./tel-input";
import TextInput from "./text-input";
import TextAreaInput from "./textarea-input";
import UrlInput from "./url-input";

interface Props {
  attrs: FormElementAttributes;
}

const FormElements: React.FC<Props> = ({ attrs }) => {
  const { tag } = attrs;
  let element: ReactElement | null = null;
  const name = attrs.commonAttrs["name"];
  const { errors } = useFormikContext<any>();
  const err = errors[name];
  const error =
    typeof err === "string"
      ? err
      : Array.isArray(err) && !!err.length
        ? typeof err[0] === "string"
          ? err[0]
          : ""
        : "";
  const hasError = !!error;

  if (tag === "text") element = <TextInput {...attrs} hasError={hasError} />;
  if (tag === "email") element = <EmailInput {...attrs} hasError={hasError} />;
  if (tag === "url") element = <UrlInput {...attrs} hasError={hasError} />;
  if (tag === "tel") element = <TelInput {...attrs} hasError={hasError} />;
  if (tag === "number")
    element = <NumberInput {...attrs} hasError={hasError} />;
  if (tag === "date") element = <DateInput {...attrs} hasError={hasError} />;
  if (tag === "textarea")
    element = <TextAreaInput {...attrs} hasError={hasError} />;
  if (tag === "select")
    element = <SelectInput {...attrs} hasError={hasError} />;
  if (tag === "checkbox")
    element = <CheckboxInput {...attrs} hasError={hasError} />;
  if (tag === "radio") element = <RadioInput {...attrs} hasError={hasError} />;
  if (tag === "file") element = <FileInput {...attrs} hasError={hasError} />;
  if (tag === "hidden") element = <HiddenInput {...attrs} />;
  if (tag === "submit") return <SubmitInput {...attrs} />;

  if (!!element)
    return (
      <>
        {element}
        {error ? (
          <label
            id={name + "-error"}
            className="form-error-validation"
            htmlFor={name}
          >
            {error}
          </label>
        ) : null}
      </>
    );

  return null;
};

export default FormElements;
